import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import VideoCard from "./VideoCard.jsx";

class VideoCardList extends Component {
  handleOnEvaluate = (video) => {
    this.props.history.push({
      pathname: `/pitchs/${video.id}`
    });
  };
  handleOnCheck = (video) => {
    this.props.history.push({
      pathname: `/pitchs/${video.id}/feedback`
    });
  };

  handleOnEdit = ({ id, title, description }) => {
    this.props.history.push({
      pathname: `/pitchs/${id}/edit`,
      search: "?",
      state: {
        video: {
          id: id,
          title: title,
          description: description
        }
      }
    });
  };

  render() {
    const {
      videos,
      isVideoCardShareable,
      isSpeechEvaluable,
      isEvaluationCheckable,
      currentUser
    } = this.props;

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center"
        }}
      >
        {videos.map(
          (
            {
              id,
              userId,
              transcodedUrl,
              thumbnail,
              title,
              description,
              createdAt,
              userName,
              userAvatar
            },
            i
          ) => (
            <VideoCard
              currentUser={currentUser}
              owner={userId}
              videoId={id}
              userName={userName}
              userAvatar={userAvatar}
              key={id}
              src={transcodedUrl}
              thumbnail={thumbnail}
              shareUrl={`https://speeker.netlify.com/pitchs/${id}`}
              title={title}
              createdAt={createdAt}
              onEvaluate={() => this.handleOnEvaluate({ id, transcodedUrl })}
              onCheck={() => this.handleOnCheck({ id })}
              onEditClick={() => this.handleOnEdit({ id, title, description })}
              isShareable={isVideoCardShareable}
              isEvaluable={isSpeechEvaluable}
              isCheckable={isEvaluationCheckable}
            />
          )
        )}
      </div>
    );
  }
}

VideoCardList.propTypes = {
  isVideoCardShareable: PropTypes.bool,
  isEvaluationCheckable: PropTypes.bool,
  currentUser: PropTypes.string.isRequired,
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      transcodedUrl: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      userName: PropTypes.string.isRequired,
      userAvatar: PropTypes.string
    })
  ).isRequired
};

VideoCardList.defaultProps = {
  isVideoCardShareable: false,
  isSpeechEvaluable: false
};

export default withRouter(VideoCardList);
